/**
 * Where the fixed header ends, for everything that has to clear it.
 *
 * Literal class strings rather than a computed one: Tailwind reads the source, so a template
 * built at runtime produces no CSS.
 */
export const HEADER_OFFSET = {
  /** Header only: 47px below `md`, 78px from `md`. */
  plain: { pad: "pt-[47px] md:pt-[78px]", below: "top-[47px] md:top-[78px]" },
  /** 32px announcement above the header. */
  announced: { pad: "pt-[79px] md:pt-[110px]", below: "top-[79px] md:top-[110px]" },
} as const;

export type HeaderOffset = (typeof HEADER_OFFSET)[keyof typeof HEADER_OFFSET];

export function headerOffset(showAnnouncement?: boolean): HeaderOffset {
  if (showAnnouncement) return HEADER_OFFSET.announced;
  return HEADER_OFFSET.plain;
}
